import _ from "lodash";
export const checkGaps = (entries) => {
    entries = entries.map((entry) => {
        entry.upFillApplicable = false;
        entry.downFillApplicable = false;
        entry.upFillHover = "";
        entry.downFillHover = "";
        return entry;
    });
    if (entries.length > 1) {
        const isAdjustModel = (entry) => "orginalStartTime" in entry;
        const allAdjust = entries.every(isAdjustModel);
        entries = _.sortBy(entries, (item) => (allAdjust ? item.orginalStartTime : item.startTime)).reverse();
        for (let i = 0; i < entries.length - 1; i++) {
            const currentEntry = entries[i];
            const nextEntry = entries[i + 1];
            if (isAdjustModel(currentEntry) && isAdjustModel(nextEntry)) {
                if (currentEntry.startTime !== nextEntry.endTime) {
                    currentEntry.downFillApplicable = true;
                    currentEntry.downFillHover = nextEntry.endTime;
                    nextEntry.upFillHover = currentEntry.startTime;
                    nextEntry.upFillApplicable = true;
                }
            }
            else {
                if (currentEntry.startTimeTzFormatted !== nextEntry.endTimeTzFormatted) {
                    currentEntry.downFillApplicable = true;
                    currentEntry.downFillHover = nextEntry.endTimeTzFormatted;
                    nextEntry.upFillHover = currentEntry.startTimeTzFormatted;
                    nextEntry.upFillApplicable = true;
                }
            }
        }
    }
    return entries;
};
